import development from './environment/development';
import testing from './environment/testing';
import production from './environment/production';
import _ from 'lodash';

const configs = {
	development,
	testing,
	production
};

const version = {
	version: {
		code: '0.0.1'
	}
};

let config = configs[process.env.NODE_ENV] || configs.development;

config = _.merge(config, version);

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js